import { faCircle, faMicrophone, faPaperPlane, faSmile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import './OwlSlider.css';
import '../ChooseLeft/Choose.css';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';

const OwlSlider = () => {
    const [index, setIndex] = useState();

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
    return (
       <div className="owl-slider">
           <div className="container">
           <div className="process col-md-12">
           <h2 className=""><span>PROCESS</span> WITH US</h2>
           <div className="separator text-center">
                    <span><FontAwesomeIcon icon={faCircle}/></span>
                </div>
           </div>
                 
            <Carousel activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <Carousel.Caption>
          <div className="owlIcon">
              <FontAwesomeIcon icon={faMicrophone}/>
              <h5>Tell us about your project</h5>
          </div>
            <div className="owlText">
              <p>Tell us about your business or project as much as possible so that our engineers can implement the industry's best technologies to your website to ensure a smooth user experience.</p>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <Carousel.Caption>
          <div className="owlIcon">
              <FontAwesomeIcon icon={faConnectdevelop}/>
              <h5>Creative Concept</h5>
          </div>
            <div className="owlText">
            <p>Tell us about your business or project as much as possible so that our engineers can implement the industry's best technologies to your website to ensure a smooth user experience.</p>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <Carousel.Caption>
          <div className="owlIcon">
              <FontAwesomeIcon icon={faPaperPlane}/>
              <h5>PLANNING, DESIGN, DEVELOPMENT</h5>
          </div>
            <div className="owlText">
            <p>Tell us about your business or project as much as possible so that our engineers can implement the industry's best technologies to your website to ensure a smooth user experience.</p>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <Carousel.Caption>
          <div className="owlIcon">
              <FontAwesomeIcon icon={faSmile}/>
              <h5>Happy Client</h5>
          </div>
            <div className="owlText">
              <p>Tell us about your business or project as much as possible so that our engineers can implement the industry's best technologies to your website to ensure a smooth user experience.</p>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
       </div>
       </div>
    );
  }

export default OwlSlider;